module.exports = __webpack_public_path__ + "assets/selected-no-code-tag.16854059.svg";